import { uiRouterActiveParamsHelperModule } from '../ui-router-active-params/ui-router-active-params';
import { uiRouterStateModule } from '../../vendor/ui-router-module';

export const scopedKeyHelperModule = angular
  .module('Q.helpers.scoped-key', [
    uiRouterStateModule,
    uiRouterActiveParamsHelperModule,
  ])

  /* eslint no-unused-vars: [2, { "args": "none" }] */ // fixes bug in ESLint that isn't seeing the usage in the default argument below
  .factory('scopedKey', function ($state, $stateParams, $location) {
    const FN_PREFIX = '?';
    const STATE_PREFIX = '@';
    const URL_PREFIX = '~';
    const STRING_PREFIX = '=';
    const PARENT_STATE_MATCHER = /\.\*$/;

    /**
     * Returns a key based on a given scope value.
     *
     * Note: It's confusing, but there really isn't a better word for this intended usage
     * than "scope".
     *
     * @param scope One of the following:
     *      'state' = current state id
     *      '<state>.*' = Matches specified parent state or any descendents
     *      array = use current state id followed by specified $stateParams
     *      'url' = full url without the hash
     *      function = return a string of your choosing
     *      anything else = converted to string, used as is
     *
     * @param stateName If provided, use this as the state name for 'state' and array scope
     * @param stateParams If provided, use this as the stateParams for array scope
     * @param url If provided, use this as the url for 'url' scope
     *
     * @returns {String}
     *
     */
    function getScopedKey(
      scope,
      stateName = $state.current.name,
      stateParams = $stateParams,
      url = $location.url(),
    ) {
      let key = '';

      if (angular.isFunction(scope)) {
        // user-defined
        key = FN_PREFIX + String(scope(stateName, stateParams, url));
      } else if (angular.isArray(scope)) {
        // state + params
        key = STATE_PREFIX + stateName + _getStateParams(scope, stateParams);
      } else if (scope === 'state') {
        // state id
        key = STATE_PREFIX + stateName;
      } else if (PARENT_STATE_MATCHER.test(scope)) {
        key =
          STATE_PREFIX +
          (_findParentScope(
            scope.replace(PARENT_STATE_MATCHER, ''),
            stateName,
          ) || stateName);
      } else if (scope === 'url') {
        // url
        key = URL_PREFIX + url.replace(/#.*/, '');
      } else {
        // some other thing
        key = STRING_PREFIX + String(scope);
      }

      return key;
    }

    /**
     * Works the same as scopedKey(), except this defaults to the activeState and activeParams, meaning if we're
     * in the middle of a transition (ie: a resolve), these will be the "to" state and params, rather than the
     * current state and params.
     *
     * @param scope
     * @param stateName
     * @param stateParams
     * @param url
     * @returns {String}
     */
    getScopedKey.activeState = function (
      scope,
      stateName = $state.activeState,
      stateParams = $state.activeParams,
      url = $location.url(),
    ) {
      return getScopedKey(scope, stateName, stateParams, url);
    };

    return getScopedKey;

    //// private methods

    function _getStateParams(scope, stateParams) {
      return (
        '({' +
        scope
          .filter(function (k) {
            return stateParams[k] !== undefined;
          })
          .map(function (k) {
            return k + ':' + String(stateParams[k]);
          })
          .join(',') +
        '})'
      );
    }

    function _findParentScope(parent, stateName) {
      if (!stateName) {
        return null;
      } else if (stateName === parent) {
        // at parent
        return parent;
      } else if (new RegExp('(^|\\.)' + parent + '\\.').test(stateName)) {
        // at parent.child
        return parent;
      } else {
        // look for manual parents
        return _findParentScope(parent, $state.get(stateName).parent);
      }
    }
  });
